import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import { OneFieldFio as Component } from '../one-field-fio';
import type { TOneFieldFio, IDeps } from '../models';

export const OneFieldFioDesktop = createWidgetWithErrorBoundary<IDeps, TOneFieldFio>()(Component);
